
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SHARED_ZORRO_MODULES } from './shared-zorro.module';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { InvoiceStatusPipe, MoneyPipe, PayStatusPipe, SafeHtmlPipe,InvoiceReceiptTypePipe,InvoiceTypePipe, InvoiceListStatusPipe, ReleaseStatusPipe, PayWayPipe, MessageStatusPipe, BalanceStatusPipe,ReimburseStatusPipe, OrderStatusPipe } from './pipe/pipe.pipe';
import { DirectiveModule } from './directive/directive.module';
import { SwiperModule } from 'swiper/angular';

import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ImgPreviewComponent } from './components/img-preview/img-preview.component';
import { PaymentComponent } from './components/payment/payment.component';

// # Angular 9 and Ionic
// yarn add angularx-qrcode@~2.3.7
// https://www.npmjs.com/package/angularx-qrcode/v/2.3.7
import { QRCodeModule } from 'angularx-qrcode';
import { QrCodeComponent } from './components/qr-code/qr-code.component';
// pdfjs pdf阅读器
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer'; // <-- Import PdfJsViewerModule module
import { BaseSearchComponent } from './components/base-search/base-search.component';
// I18N
import {TranslateModule} from '@ngx-translate/core';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SearchListComponent } from './components/search-list/search-list.component';
import { FormFileSelectComponent } from './components/form-file-select/form-file-select.component';
import { CounterComponent } from './components/counter/counter.component';
import { ContactusModalComponent } from './components/contactus-modal/contactus-modal.component';
const components = [
  BreadcrumbComponent,
  FileUploadComponent,
  ImgPreviewComponent,
  PaymentComponent,
  QrCodeComponent,
  BaseSearchComponent,
  PaginationComponent,
  SearchListComponent,
  FormFileSelectComponent,
  CounterComponent,
  ContactusModalComponent,
];

const Modules = [
  DirectiveModule,
  FormsModule,
  ReactiveFormsModule,
  NzCarouselModule,
  RouterModule,
  SwiperModule,
  QRCodeModule,
  SHARED_ZORRO_MODULES,
  PdfJsViewerModule,
  TranslateModule
];

const PIPE = [
  SafeHtmlPipe,
  InvoiceStatusPipe,
  PayStatusPipe,
  ReimburseStatusPipe,
  MoneyPipe,
  InvoiceReceiptTypePipe,
  InvoiceTypePipe,
  InvoiceListStatusPipe,
  ReleaseStatusPipe,
  PayWayPipe,
  MessageStatusPipe,
  BalanceStatusPipe,
  OrderStatusPipe
];

@NgModule({
  declarations: [
    ...components,
    ...PIPE
  ],
  imports: [
    CommonModule,
    ...Modules,
  ],
  exports: [
    ...components,
    ...Modules,
    ...PIPE
  ]
})
export class SharedModule { }
